import { type FC } from "react";

import { AssessmentProgressBar } from "components/footer/AssessmentProgressBar";
import { InstructorMainFooter } from "components/footer/InstructorMainFooter";
import { RecordingAgentMainFooter } from "components/footer/RecordingAgentMainFooter";
import { StudentMainFooter } from "components/footer/StudentMainFooter";
import { useIsAssessing } from "components/materials/section/assessment/hooks";
import { useCapabilities } from "store/capability-hooks";
import { useAppSelector } from "store/index";
import { selectCurrentSectionId, selectIsRecordingAgent, selectPageById } from "store/selectors";
import { useParams } from "utils/routing";

export const MainFooter: FC = () => {
  const pathParams = useParams();
  const selectedPageId = pathParams.pageId;
  const sectionId = useAppSelector(selectCurrentSectionId);
  const selectedPage = useAppSelector((s) => selectPageById(s, selectedPageId));
  const isAssessing = useIsAssessing();
  const { canAuthorSection } = useCapabilities();
  const isRecordingAgent = useAppSelector(selectIsRecordingAgent);

  if (!sectionId) {
    return null;
  }

  if (isRecordingAgent) {
    return <RecordingAgentMainFooter selectedPage={selectedPage} />;
  }

  if (!canAuthorSection) {
    return <StudentMainFooter selectedPage={selectedPage} />;
  }

  if (isAssessing) {
    return <AssessmentProgressBar selectedPage={selectedPage} />;
  }

  return <InstructorMainFooter selectedPage={selectedPage} />;
};
